import React, { useEffect, useState } from 'react';
import { useWebSocket } from 'src/contexts/webSocketContext';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import axiosInstance from 'src/utils/axios';
import { message } from 'antd';
import { signOut } from 'src/auth/context/jwt/action';
import { useAuthContext } from 'src/auth/hooks';

export const AuthSocketWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { socket } = useWebSocket();
  const [requestQueue, setRequestQueue] = useState<any[]>([]);
  const { checkUserSession } = useAuthContext();

  useEffect(() => {
    if (!socket) return;

    const handleLoginRequest = (data: any) => {
      // data: { requestId, ipAddress, deviceInfo: { browser, os, ... } }
      setRequestQueue((prev) => [...prev, data]);
      
      // Auto-hide after 60s
      setTimeout(() => {
        setRequestQueue((prev) => prev.filter((item) => item.requestId !== data.requestId));
      }, 60000);
    };

    socket.on('login_request', handleLoginRequest);

    return () => {
      socket.off('login_request', handleLoginRequest);
    };
  }, [socket]);

  const currentRequest = requestQueue[0];

  const handleApprove = async () => {
    if (!currentRequest) return;
    try {
      await axiosInstance.post(`/auth/approve-login/${currentRequest.requestId}`);
      message.success('Đã phê duyệt. Trình duyệt của bạn sẽ tự động đăng xuất.');
      
      try {
        await signOut();
        await checkUserSession?.();
      } catch (logoutError) {
        console.error('Logout failed:', logoutError);
      }
      
      window.location.reload();
      setRequestQueue((prev) => prev.slice(1));
    } catch (error: any) {
      message.error(error?.message || 'Phê duyệt thất bại');
      setRequestQueue((prev) => prev.slice(1));
    }
  };

  const handleReject = () => {
    setRequestQueue((prev) => prev.slice(1));
  };

  return (
    <>
      {children}
      
      <Dialog open={!!currentRequest} onClose={handleReject}>
        <DialogTitle>Yêu cầu phê duyệt đăng nhập</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Chúng tôi phát hiện một thiết bị mới đang cố gắng đăng nhập vào tài khoản của bạn.
            <br /><br />
            <strong>Thông tin thiết bị:</strong><br />
            - IP: {currentRequest?.ipAddress || 'Không rõ'}<br />
            - Trình duyệt/App: {currentRequest?.deviceInfo?.browser || 'Không rõ'}<br />
            - Hệ điều hành: {currentRequest?.deviceInfo?.os || 'Không rõ'}
            <br /><br />
            <em>Lưu ý: Nếu bạn chọn Phê duyệt, thiết bị hiện tại của bạn sẽ bị đăng xuất. Yêu cầu này sẽ tự hết hạn trong 60s.</em>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReject} color="inherit">
            Từ chối
          </Button>
          <Button onClick={handleApprove} variant="contained" color="primary">
            Phê duyệt
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
